import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, InputGroup, Label, Row } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { SketchPicker } from "react-color"
import ColorPicker from "@vtaits/react-color-picker"
import "@vtaits/react-color-picker/dist/index.css"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Switch from "react-switch"
import Select from "react-select"
import makeAnimated from "react-select/animated"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import PropTypes from "prop-types"
//Import Breadcrumb
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter, Link } from "react-router-dom";
import { editGtwo, getGtwo } from '../../../actions/api';

const animatedComponents = makeAnimated()

const compManufacturer = [
    { label: "Hamilton Sundstrand", value: "Hamilton Sundstrand" },
    { label: "Honeywell International", value: "Honeywell International" },
    { label: "Pratt&Whitney Canada", value: "Pratt&Whitney Canada" },
    { label: "Eaton Aerospace", value: "Eaton Aerospace" },
    { label: "Honeywell ASCA", value: "Honeywell ASCA" },
    { label: "CFM International", value: "CFM International" },
    { label: "BAe Systems", value: "BAe Systems" },
    { label: "Rockwell Collins", value: "Rockwell Collins" },
    { label: "Eldec Corporation", value: "Eldec Corporation" },
    { label: "Sensor Systems", value: "Sensor Systems" },
    { label: "GE Aviation Systems", value: "GE Aviation Systems" },
    { label: "BF Goodrich Rosemount", value: "BF Goodrich Rosemount" },
    { label: "Safran Landing Systems", value: "Safran Landing Systems" },
]

const compClass = [
    { label: "Active", value: "Active" },
    { label: "Obsolete", value: "Obsolete" },
    { label: "Superseded", value: "Superseded" },
    { label: "Alternative", value: "Alternative" },
]

const compClassLinkage = [
    { label: "Subassembly", value: "Subassembly" },
    { label: "Single", value: "Single" },
    { label: "Consumable", value: "Consumable" },
]

const aircraftTypes = [
    { label: "B737-700", value: "B737-700" },
    { label: "B737-800", value: "B737-800" },
    { label: "B737-900", value: "B737-900" },
    { label: "B737-900ER", value: "B737-900ER" },
    { label: "A320-200", value: "A320-200" },
    { label: "ATR72-500", value: "ATR72-500" },
    { label: "ATR72-600", value: "ATR72-600" },
]

const currency = [
    { label: "MYR", value: "MYR" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" },
]


const ViewPanelGtwoForm = (props) => {
    const { history } = props;
    const { match: { params } } = props
    const [gtwo, setGtwo] = useState([]);
    let gtwoComponent = [];
    const gtwoComp = gtwo?.map(n => n.comp_name)
    gtwoComp.forEach((n, i) => {
        gtwoComponent.push({
            label: n,
            value: n
        })
    })
    const [form, setForm] = useState({});
    const [compRow, setCompRow] = useState({})
    const [thresh, setThresh] = useState({})
    const [threshCount, setThreshCount] = useState({})

    const compClassChangeDate = form.comp_class_change_date ? new Date(form.comp_class_change_date) : null;

    useEffect(() => {
        getGtwo()
            .then(resp => {
                const filterGtwo = resp.find(x => x.id === parseInt(params.id))
                const compMfr = [{ label: filterGtwo.comp_manufacturer, value: filterGtwo.comp_manufacturer }]
                filterGtwo.comp_manufacturer = compMfr;
                const compClas = [{ label: filterGtwo.comp_class, value: filterGtwo.comp_class }]
                filterGtwo.comp_class = compClas;
                const compClasLink = [{ label: filterGtwo.comp_class_linkage, value: filterGtwo.comp_class_linkage }]
                filterGtwo.comp_class_linkage = compClasLink;
                if (typeof filterGtwo.comp_build_out === 'string') {
                    filterGtwo.comp_build_out = JSON.parse(filterGtwo.comp_build_out)
                }
                if (typeof filterGtwo.aircraft_model === 'string') {
                    filterGtwo.aircraft_model = JSON.parse(filterGtwo.aircraft_model)
                }
                if (typeof filterGtwo.est_cur === 'string') {
                    filterGtwo.est_cur = JSON.parse(filterGtwo.est_cur)
                }
                if (typeof filterGtwo.quote_cur === 'string') {
                    filterGtwo.quote_cur = JSON.parse(filterGtwo.quote_cur)
                }
                setForm(filterGtwo)
            })
    }, []);

    function handleThresholdChange(event) {
        const { name, value } = event.target;
        thresh[name] = value.length
        const remain_val = 40 - 35

        if (remain_val <= thresh[name]) {
            setThresh({ ...thresh, [name]: true })
        } else {
            setThresh({ ...thresh, [name]: false })
        }
        setThreshCount({ ...threshCount, [name]: event.target.value.length })
    }

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    function handleAddRowNested(value) {
        // const modifiedRows = [...rows1]
        // modifiedRows.push({ comp_build_out: '' })
        // setrows1(modifiedRows)
        let modifiedRows = [];
        for (let i = 0; i < value; i++) {
            modifiedRows.push({ subComp: '' })
        }
        setCompRow(modifiedRows)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const id = parseInt(params.id)
        //form.comp_build_out = compRow;
        editGtwo(form, id)
            .then(async (resp) => {
                await getGtwo()
                    .then(respo => {
                        setGtwo(respo)
                        history.push('/panelg2')
                    })
            })
            .catch(err => {
                console.log("Error", err);
            })
    }

    const handleCancel = () => {
        history.push('/panelg2')
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Fleet Configuration | Component List Setup</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title="Configuration" breadcrumbItem="Component List Setup" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <AvForm onValidSubmit={handleSubmit}>
                                        <Row>
                                            <Col>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Manufacturer
                                                    </label>
                                                    <div className="col-md-9">
                                                        {/* <AvField type="text" disabled name="comp_manufacturer" value={form.comp_manufacturer} /> */}
                                                        <Select
                                                            value={form.comp_manufacturer}
                                                            onChange={(value) => {
                                                                setForm({ ...form, comp_manufacturer: value })
                                                            }}
                                                            options={compManufacturer}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Name
                                                    </label>
                                                    <div className="col-md-9">
                                                        <AvField type="text" maxLength={40} name="comp_name" value={form.comp_name}
                                                            onChange={e => {
                                                                handleThresholdChange(e)
                                                                handleChange(e)
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            autoComplete="off"
                                                            errorMessage="Enter Component Name"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                        {thresh.comp_name ? (
                                                            <span className="badgecount badge bg-success">
                                                                {threshCount.comp_name} / 40{" "}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Part No
                                                    </label>
                                                    <div className="col-md-9">
                                                        <AvField type="text" maxLength={40} name="comp_part_no" value={form.comp_part_no}
                                                            onChange={e => {
                                                                handleThresholdChange(e)
                                                                handleChange(e)
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            autoComplete="off"
                                                            errorMessage="Enter Component Part No"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                        {thresh.comp_part_no ? (
                                                            <span className="badgecount badge bg-success">
                                                                {threshCount.comp_part_no} / 40{" "}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        CMM No
                                                    </label>
                                                    <div className="col-md-9">
                                                        <AvField type="text" maxLength={40} name="cmm" value={form.cmm}
                                                            onChange={e => {
                                                                handleThresholdChange(e)
                                                                handleChange(e)
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            autoComplete="off"
                                                            errorMessage="Enter CMM"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                        {thresh.cmm ? (
                                                            <span className="badgecount badge bg-success">
                                                                {threshCount.cmm} / 40{" "}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Classification
                                                    </label>
                                                    <div className="col-md-9">
                                                        {/* <AvField type="text" maxLength={40} disabled name="comp_class" value={form.comp_class} /> */}
                                                        <Select
                                                            value={form.comp_class}
                                                            onChange={(value) => {
                                                                setForm({ ...form, comp_class: value })
                                                            }}
                                                            options={compClass}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Classification Changed Date
                                                    </label>
                                                    <div className="col-md-9">
                                                        <DatePicker
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="DD/MM/YYYY"
                                                            selected={compClassChangeDate}
                                                            onChange={(date) => setForm({ ...form, comp_class_change_date: date })}
                                                        />
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Component Class Linkage
                                                    </label>
                                                    <div className="col-md-9">
                                                        {/* <AvField type="text" maxLength={40} disabled name="comp_class_linkage" value={form.comp_class_linkage} /> */}
                                                        <Select
                                                            value={form.comp_class_linkage}
                                                            onChange={(value) => {
                                                                setForm({ ...form, comp_class_linkage: value })
                                                            }}
                                                            options={compClassLinkage}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                </Row>

                                                {form?.comp_class_linkage?.value === 'Subassembly' ?
                                                    <Row className="mb-3">
                                                        <label
                                                            htmlFor="example-text-input"
                                                            className="col-md-3 col-form-label"
                                                        >
                                                            No of SubComponents
                                                        </label>
                                                        <div className="col-md-9">
                                                            <AvField type="number" maxLength={10} name="sub_comp" value={form.sub_comp}
                                                                onChange={e => {
                                                                    handleChange(e)
                                                                    handleAddRowNested(e.target.value)
                                                                }}
                                                                onPaste={(e) => {
                                                                    e.preventDefault()
                                                                    return false;
                                                                }}
                                                                onCopy={(e) => {
                                                                    e.preventDefault()
                                                                    return false;
                                                                }}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    </Row>
                                                    : null
                                                }
                                                {form.sub_comp && (compRow || []).map((el, i) => (
                                                    <Row className="mb-3" key={i}>
                                                        <label
                                                            htmlFor="example-text-input"
                                                            className="col-md-3 col-form-label"
                                                        >
                                                            SubComponent
                                                        </label>
                                                        <div className="col-md-9">
                                                            <Select
                                                                value={compRow.subComp}
                                                                onChange={(value) => {
                                                                    const tempValues = [...compRow];
                                                                    tempValues[i] = { ...tempValues[i], subComp: value };
                                                                    setCompRow(tempValues);
                                                                }}
                                                                options={gtwoComponent}
                                                                classNamePrefix="select2-selection"
                                                            />
                                                        </div>
                                                    </Row>
                                                )
                                                )}


                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Compatibility to Aircraft Model
                                                    </label>
                                                    <div className="col-md-9">
                                                        <Select
                                                            value={form.aircraft_model}
                                                            isMulti={true}
                                                            onChange={(value) => {
                                                                setForm({ ...form, aircraft_model: value })
                                                            }}
                                                            options={aircraftTypes}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Estimated Price
                                                    </label>
                                                    <div className="col-md-3">
                                                        <Select
                                                            value={form.est_cur}
                                                            onChange={(value) => {
                                                                setForm({ ...form, est_cur: value })
                                                            }}
                                                            options={currency}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <AvField type="number" maxLength={10} name="est_price" value={form.est_price}
                                                            onChange={e => {
                                                                handleChange(e)
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </Row>

                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="example-text-input"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Quotation Price
                                                    </label>
                                                    <div className="col-md-3">
                                                        <Select
                                                            value={form.quote_cur}
                                                            onChange={(value) => {
                                                                setForm({ ...form, quote_cur: value })
                                                            }}
                                                            options={currency}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <AvField type="number" maxLength={10} name="quote_price" value={form.quote_price}
                                                            onChange={e => {
                                                                handleChange(e)
                                                            }}
                                                            onPaste={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault()
                                                                return false;
                                                            }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </Row>

                                                <Row>
                                                    <Col className="d-flex flex-wrap gap-2 justify-content-center">
                                                        <Button className=" btn btn-success save-user w-md"
                                                            type="submit"
                                                        >
                                                            Update
                                                        </Button>
                                                        <Button type="reset" color="secondary" onClick={handleCancel}
                                                            className=" btn btn-secondary save-user w-md">
                                                            Cancel
                                                        </Button>
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

ViewPanelGtwoForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.any,
}

export default withRouter(ViewPanelGtwoForm)